<template>
  <h2 class="section__title section__title--error">{{ $t('main-page.rejected.back-to-pharmacy.on-its-way-to-pharmacy') }}</h2>
</template>

<script>
export default {
  name: 'on-its-way-to-pharmacy',
}
</script>
